DJ.addBehavior('menu', '.main-menu', {
    attach: function(context, settings, behavior) {

        // mobile burger menu, open menu (mobile)
        var burgerLink = jQuery('.burger-link');
        var body = jQuery('body');
        var oneTwoColSelector = '.header-drop-down-holder.menu-onetwocol';

        function hideOneTwoColPanels() {
          jQuery(oneTwoColSelector).each(function () {
            const $holder = jQuery(this);
            $holder
              .find('.header-drop-down-left a.menu-interaction[data-sublabel]')
              .removeClass('is-submenu-open');
            $holder
              .find('.header-drop-down-left .accordion-opener')
              .removeClass('is-megamenu-active');
            $holder
              .find('.header-drop-down-frame .block-biogaran-menu-submenu-thumbnails-block')
              .hide();
            $holder
              .find('.header-drop-down-frame .js-menu-submenu-group')
              .hide()
              .removeClass('is-active')
              .attr('aria-hidden', 'true');
          });
        }

        function updateBurgerAria(isOpen) {
            burgerLink.attr('aria-expanded', isOpen ? 'true' : 'false');
            burgerLink.attr(
              'aria-label',
              isOpen ? Drupal.t('Fermer le menu principal') : Drupal.t('Ouvrir le menu principal')
            );
        }

        function clickOnBurgerMenu() {

            var isActive = burgerLink.hasClass('close');

            if (isActive) {
                burgerLink.removeClass('close');
                burgerLink.addClass('open');
                body.addClass('mobile-dropdown-opened');
                updateBurgerAria(true);
            }
            else {
                burgerLink.removeClass('open');
                burgerLink.addClass('close');
                body.removeClass('mobile-dropdown-opened');
                body.removeClass('nav-is-opened');
                jQuery('.main-menu-list > li').removeClass('opened');
                jQuery('.js-back-button').removeClass('opened');
                hideOneTwoColPanels();
                updateBurgerAria(false);
            }
        }

        // Initialisation des attributs ARIA au chargement
        if (burgerLink.length) {
            updateBurgerAria(false);
        }

        burgerLink.on('click', clickOnBurgerMenu);

      jQuery('.main-menu-list > li > button').click(function (){
        const self = jQuery(this);
        const items = self.parents('li').siblings();
        const currentItem = self.parents('li');
        const menuWrapper = self.parents('.header__menu');
        hideOneTwoColPanels();
        items.not(currentItem).removeClass('opened');

        if (currentItem.hasClass('opened')) {
          currentItem.removeClass('opened');
          body.removeClass('nav-is-opened');
          self.attr('aria-expanded', false);
        } else {
          menuWrapper.scrollTop(0);
          var text = self.find('.opener-dropdown').text();
          jQuery('.js-back-button').addClass('opened').find('.js-back-button-label').text(text);
          currentItem.addClass('opened');
          body.addClass('nav-is-opened');
          self.attr('aria-expanded', true);

          currentItem.focusout(function(e) {
            if (!e.currentTarget.contains(e.relatedTarget) && window.innerWidth > 974) {
              currentItem.removeClass('opened');
              body.removeClass('nav-is-opened');
              self.attr('aria-expanded', false);
              jQuery('.js-back-button').removeClass('opened');
              hideOneTwoColPanels();
            }
          });
        }
      });

      jQuery('.main-menu-list > li').keyup(function(e) {
        if (e.key === "Escape") {
          const self = jQuery(this);
          self.removeClass('opened');
          self.find('button').attr('aria-expanded', false);
          self.find('.header-drop-down').focus();
          jQuery('.js-back-button').removeClass('opened');
          hideOneTwoColPanels();
        }
      });

      jQuery('.js-back-button').click(function () {
        jQuery(this).removeClass('opened').find('.js-back-button-label').text('');
        jQuery('.main-menu-list > li').removeClass('opened');
        body.removeClass('nav-is-opened');
        hideOneTwoColPanels();
      });

      function normalizeMenuLabel(value) {
        if (!value) {
          return '';
        }

        return value
          .toString()
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
      }

      jQuery(oneTwoColSelector).each(function () {
        const $holder = jQuery(this);
        const $accordionButtons = $holder.find('.header-drop-down-left .accordion-opener .opener button[data-sublabel]');
        const $groups = $holder.find('.header-drop-down-frame .js-menu-submenu-group');
        const $panels = $holder.find('.header-drop-down-frame .block-biogaran-menu-submenu-thumbnails-block');

        if (!$accordionButtons.length || !$groups.length || !$panels.length) {
          return;
        }

        // Masque les blocs + groupes de droite au chargement.
        $panels.hide();
        $groups.hide().removeClass('is-active').attr('aria-hidden', 'true');

        if ($holder.data('menuOneTwoColBound')) {
          return;
        }
        $holder.data('menuOneTwoColBound', true);

        const isDesktop = window.innerWidth > 974;
        if (isDesktop) {
          // Desktop: on ferme aussi le sous-menu gauche pour éviter qu'il s'affiche
          // au clic sur l'accordion.
          $holder
            .find('.header-drop-down-left .accordion-opener.opened')
            .removeClass('opened')
            .find('.slide')
            .hide()
            .addClass('js-slide-hidden');
          $holder
            .find('.header-drop-down-left .accordion-opener .opener button')
            .attr('aria-expanded', 'false');
        }

        $accordionButtons
          .off('click.menuOneTwoColSubmenuTiles')
          .on('click.menuOneTwoColSubmenuTiles', function (e) {
            const $button = jQuery(this);
            const $accordionOpener = $button.closest('.accordion-opener');
            const buttonLabel = normalizeMenuLabel($button.attr('data-sublabel') || $button.text());

            const $allGroups = $holder.find('.header-drop-down-frame .js-menu-submenu-group');
            const $allPanels = $holder.find('.header-drop-down-frame .block-biogaran-menu-submenu-thumbnails-block');

            const $targetGroups = $allGroups.filter(function () {
              const groupTitle = normalizeMenuLabel(jQuery(this).attr('data-menu-link-title'));
              return groupTitle === buttonLabel;
            });
            const $targetPanels = $targetGroups.closest('.block-biogaran-menu-submenu-thumbnails-block');

            if (!$targetGroups.length) {
              $allPanels.hide();
              $allGroups.hide().removeClass('is-active').attr('aria-hidden', 'true');
              return;
            }

            // Desktop: accordion gauche bloqué => on pilote uniquement l'affichage des thumbnails (toggle sur is-active).
            if (isDesktop) {
              // Bloque l'ouverture du sous-menu gauche (accordéon Drupal openClose),
              // mais on continue à piloter l'affichage des thumbnails à droite.
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();

              const isAlreadyActive = $targetGroups.first().hasClass('is-active');

              // État visuel (trait + couleur) sans ouvrir le sous-menu.
              $holder
                .find('.header-drop-down-left .accordion-opener')
                .not($accordionOpener)
                .removeClass('is-megamenu-active');

              $allPanels.hide();
              $allGroups.hide().removeClass('is-active').attr('aria-hidden', 'true');

              if (!isAlreadyActive) {
                $accordionOpener.addClass('is-megamenu-active');
                $button.attr('aria-expanded', 'false');
                $targetPanels.show();
                $targetGroups.show().addClass('is-active').attr('aria-hidden', 'false');
              } else {
                $accordionOpener.removeClass('is-megamenu-active');
              }

              return;
            }

            // Mobile: on attend que Drupal/accordion-opener mette à jour la classe `.opened`.
            setTimeout(function () {
              const isOpened = $accordionOpener.hasClass('opened');

              $allPanels.hide();
              $allGroups.hide().removeClass('is-active').attr('aria-hidden', 'true');

              if (isOpened) {
                $targetPanels.show();
                $targetGroups.show().addClass('is-active').attr('aria-hidden', 'false');
              }
            }, 0);
          });
      });
    },

    detach: function(context, settings) {}
});
